import type { SVGProps } from 'react';
const SvgIconLogout = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M1 3.75A2.75 2.75 0 0 1 3.75 1h5.5a2.75 2.75 0 0 1 2.646 2H10.25a1.25 1.25 0 0 0-1-.5h-5.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h5.5c.409 0 .772-.196 1-.5h1.646a2.75 2.75 0 0 1-2.646 2h-5.5A2.75 2.75 0 0 1 1 12.25z"
    />
    <path
      fill="currentColor"
      d="M11.47 11.005a.75.75 0 0 1 0-1.06l1.194-1.195H6.75a.75.75 0 0 1 0-1.5h5.914L11.47 6.055a.75.75 0 0 1 1.06-1.06l2.122 2.121a1.25 1.25 0 0 1 0 1.768l-2.122 2.121a.75.75 0 0 1-1.06 0"
    />
  </svg>
);
export default SvgIconLogout;
